import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Button, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { loginSourceSelector } from '../../redux/core/sourceData/sourceDataSlice.js';
import { RegistrationWithEmailForm } from '../Registration/components/RegistrationWithEmailForm/index.js';
import { RegistrationAlert } from '../Registration/components/RegistrationAlert/index.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { useTranslatedSourceOverrideLabel } from '../../helpers/useTranslatedLabel.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { TwoStepConsent } from '../../components/TwoStepConsent/index.js';
import { registrationConsentPositionSelector } from '../../redux/core/siteConfig/siteConfigSlice.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const TwoStepRegistration = () => {
    const dispatch = useAppDispatch();
    const loginSource = useAppSelector(loginSourceSelector);
    const registrationConsentPosition = useAppSelector(registrationConsentPositionSelector);
    const { t } = useTranslation();
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('twoStep');
    useEffect(() => {
        trackModalComponentVisible();
    }, []);
    const headerLabel = useSourceOverrideLabel('twoStepLoginRegistration.registration.header');
    const onShowAllOptions = (e) => {
        trackBtnClick({ uniqueName: 'showAllOptions' });
        e.preventDefault();
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER));
    };
    // For successful registration registrationSlice redirect to candidate/register/success page
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "registration-form", children: [_jsx(ContentHeading, { label: headerLabel }), _jsx(RegistrationAlert, {}), _jsx(RegistrationWithEmailForm, {}), _jsx(Button, { variant: "link", a11yLabel: "back-to-email-address", "data-testid": "back-to-email-address-link", onClick: (e) => onShowAllOptions(e), children: t('loginregistration.twoStepLoginRegistration.registration.backLink') }), registrationConsentPosition === 'bottom' && (_jsx(TwoStepConsent, { label: t('loginregistration.twoStepLoginRegistration.registration.legalNote'), variant: "registration" }))] }));
};
//# sourceMappingURL=TwoStepRegistration.js.map